import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import {
  IAssignTicketsPayload,
  IIssueTypeImplementationPayload,
  ITaskInProgressParams,
  ITaskInProgressResponse,
  IUploadMidTidResponse,
} from 'interfaces';

const uploadFileMidTid = (payload: {
  filePath: string;
}): Promise<IUploadMidTidResponse> => {
  return bffServiceClient
    .post(`/ticket/uploadImplementationTerminal`, payload)
    .then(getResult);
};

const postIssueTypeImplementation = (
  payload: IIssueTypeImplementationPayload
): Promise<{}> => {
  return bffServiceClient.post('/issueType/startImplementation', payload);
};

const getTaskInProgress = (
  params: ITaskInProgressParams
): Promise<ITaskInProgressResponse> => {
  return bffServiceClient
    .get('/ticket/implementation', { params })
    .then(getResult);
};

const assignTickets = (params: IAssignTicketsPayload): Promise<{}> => {
  return bffServiceClient.put('/ticket/assigns', params);
};

export default {
  uploadFileMidTid,
  postIssueTypeImplementation,
  getTaskInProgress,
  assignTickets,
};
